import React from "react";
import ph_whatsapp_logo_thin from "../assets/icons/ph_whatsapp_logo_thin.png";
import ph_phone_call_light from "../assets/icons/ph_phone_call_light.png";
import circum_mail from "../assets/icons/circum_mail.png";

const TransferUserRow = ({
  userImg,
  name,
  mobileNumber,
  email,
  lastInteracted,
  company,
}) => {
  return (
    <div className="flex items-center text-[14px] mt-4 mb-4 w-full overflow-auto">
      <div className="flex items-center w-[13rem]">
        <input type="checkbox" className="" />
        <div>
          <img
            src={userImg}
            alt="user image"
            className="w-[40px] rounded-full mx-2"
          />
        </div>
        <div className="font-bold">{name}</div>
      </div>
      <div className="w-[10rem]">+91 {mobileNumber}</div>
      <div className="w-[13rem]">{email}</div>
      <div className="w-[10rem]">{lastInteracted}</div>
      <div className="w-[10rem]">{company}</div>
      <div className="flex mr-4">
        <div className="mr-4 cursor-pointer w-full">
          <img src={ph_phone_call_light} className="w-7" alt="phone" />
        </div>
        <div className="mr-4 cursor-pointer w-full">
          <img src={circum_mail} className="w-7" alt="phone" />
        </div>
        <div className=" cursor-pointer w-full">
          <img src={ph_whatsapp_logo_thin} className="w-7" alt="phone" />
        </div>
      </div>
    </div>
  );
};

export default TransferUserRow;
